/** The app's repository (api/openapi.yaml `/apps/{appId}/source`): what Hangar's runner fetches for a `hangar_runner` build. */
import { App, type AppSourceRequest } from '@hangar/shared';
import { api } from './client';

const enc = encodeURIComponent;

/** Links the app to a repository of a Bitbucket connection (Bitbucket is asked first); admin or the project's maintainer. */
export const linkAppSource = (appId: string, body: AppSourceRequest) => api('PUT', `/apps/${enc(appId)}/source`, { schema: App, body });

/** Removes the link (a "Create on Bitrise" link stays). */
export const unlinkAppSource = (appId: string) => api('DELETE', `/apps/${enc(appId)}/source`, { schema: App });
